const isValidPercentage = (value) => {
    if (value === null || value === undefined || value === '') {
        return false
    }

    const num = typeof value === 'number' ? value : Number(value)
    return !isNaN(num) && isFinite(num)
}

export const SCORE_TYPE = {
    IN: 'in',
    OUT: 'out'
}

export const calculateBlueskyScorePercentage = (scoreIn, scoreOut, calculateWhichScore = SCORE_TYPE.IN) => {
    // Only return a percentage if both scores are valid numbers. If one is missing or invalid, assume both are invalid.
    const hasValidScores = isValidPercentage(scoreIn) && isValidPercentage(scoreOut)

    if (!hasValidScores) {
        return undefined
    }

    const score = calculateWhichScore === SCORE_TYPE.IN ? scoreIn : scoreOut
    return `${(score * 100).toFixed(0)}`
}